import { PointOptionsObject, SeriesOptions } from 'highcharts';

export const ADVISER_AREA_SUBTITLE = "How would you describe the client's investment style?";
export const CONSUMER_AREA_SUBTITLE = 'How would you describe your investment style?';
export const FETCH_RISK_TOLERANCE = 'RISK_TOLERANCE/FETCH';
export const ASSIGN_RISKALYZE_PORTFOLIO = 'RISK_TOLERANCE/ASSIGN_RISKALYZE_PORTFOLIO';

export const CHART_OPTIONS: Highcharts.Options = {
  chart: {
    height: 150,
    plotBackgroundColor: undefined,
    plotBorderWidth: undefined,
    plotShadow: false,
    backgroundColor: 'transparent',
    spacing: [0, 0, 0, 0],
  },
  title: {
    text: '',
  },
  legend: {
    layout: 'vertical',
    verticalAlign: 'middle',
    align: 'left',
    floating: true,
    x: 190,
    useHTML: true,
    labelFormatter(this: (SeriesOptions & { y: number }) | PointOptionsObject) {
      return `
        <div style="display: flex; flex-direction: row; justify-content: space-between; width: 180px; margin-top: -1px;">
          <div style="
            display: inline-block;
            vertical-align: middle;
            text-align: left;
            font-size: 14px;
            font-family: Open Sans,helvetica,sans-serif;
            position: relative;
            color: #444;
            font-weight: 400;
            width: 135px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          ">
            ${this.name}
          </div>
          <div style="
            width: 35px;
            color: #6C727F;
            font-weight: 400;
            text-align: right;
            display: inline-block;
            vertical-align: middle;
            font-size: 14px;
            font-family: Open Sans,helvetica,sans-serif;
            position: relative;
          ">
            ${ADV.util.number_format((this.y || 0) * 100)}%
          </div>
        </div>
      `;
    },
    itemStyle: {
      lineHeight: '14px',
    },
    itemMarginBottom: 12,
    itemMarginTop: 4,
    squareSymbol: false,
    symbolHeight: 14,
    symbolWidth: 5,
    symbolRadius: 4,
    symbolPadding: 16,
  },
  tooltip: {
    enabled: false,
  },
  plotOptions: {
    pie: {
      slicedOffset: 0,
      size: 150,
      center: [75, 75],
      innerSize: '65%',
      dataLabels: {
        enabled: false,
      },
      allowPointSelect: false,
      point: {
        events: {
          legendItemClick() {
            return false;
          },
        },
      },
      showInLegend: true,
    },
    series: {
      states: {
        hover: {
          enabled: false,
        },
      },
    },
  },
  series: [
    {
      type: 'pie',
      name: 'Asset Allocation',
      data: [],
    },
  ],
  credits: {
    enabled: false,
  },
};
